import { render, staticRenderFns } from "./AuctionBidding.vue?vue&type=template&id=425cb924&scoped=true&lang=pug"
import script from "./AuctionBidding.vue?vue&type=script&lang=ts"
export * from "./AuctionBidding.vue?vue&type=script&lang=ts"
import style0 from "./AuctionBidding.vue?vue&type=style&index=0&id=425cb924&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425cb924",
  null
  
)

export default component.exports